<div class="main-content-container">
  <div class="main-container-body">
    <div [ngClass]="utilService.isMobile()?'tracksampledotmob':'tracksampledot'">
      <div class="text-capitalize" [ngClass]="utilService.isMobile()?'_wf-sdts-allpointstop':'_wf-dts-navpoints'">
        <div [ngClass]="utilService.isMobile()?'_wf-dts-mob':'_wf-dts-rgtpoints'">
          <div [ngClass]="utilService.isMobile()?'_wf-sbts-trackfirstpoint':'_wf-dts-firstpoint'">
            <div class="text-block-230"><i class="fa fa-circle" style="color:rgb(233, 230, 62); "></i></div>
            <div class="text-block-231">Pending</div>
          </div>
          <div [ngClass]="utilService.isMobile()?'_wf-sbts-trackfirstpoint':'_wf-dts-firstpoint'">
            <i class="fa fa-circle" style="color: #44cdf7cb;"></i>
            <div class="text-block-231">Completed</div>
          </div>
          <div [ngClass]="utilService.isMobile()?'_wf-sbts-trackfirstpoint':'_wf-dts-firstpoint'">
            <i class="fa fa-circle" style="color: rgb(224, 24, 24);"></i>
            <div class="text-block-231">Cancelled</div>
          </div>
          <div [ngClass]="utilService.isMobile()?'_wf-sbts-trackfirstpoint':'_wf-dts-firstpoint'">
            <i class="fa fa-circle" style="color: rgb(0, 0, 0);"></i>
            <div class="text-block-231">NA</div>
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center ml-2 mr-2">
        <!-- <div *ngIf="resouceDef.filter_form != undefined">
        <button type="button" class="secondary-btn" (click)="displayFilter()">
          <span>Filter</span>
          <i class="fa fa-filter" aria-hidden="true"></i>
        </button>
      </div> -->
      <div class="_filter-button-wrapper">
        @if (resouceDef.filter_form != undefined) {
          <div class="_filter-button" (click)="displayFilter()">
            <i class="fa fa-filter" aria-hidden="true"></i>
          </div>
        }
      </div>
      <div style="margin-left: 1px;">
        <div class="grid-search-container mr-2">
          <!-- <div class="grid-smart-search-container d-flex align-items-center">
          <span class="grid-smart-search" id="basic-addon2" (click)="searchFilter(searchKey)"><i class="fa fa-search" aria-hidden="true"></i></span>
          <input type="text" class="search form-control" pattern="[^A-Za-z0-9]" [(ngModel)]="searchKey" placeholder="Search" (keydown)="searchFilter($event.target.value)">
        </div> -->
        <app-complex-search [config]="searchConfig" (onFilterChange)="filterClick($event);">
        </app-complex-search>
      </div>
    </div>
    <div class="ml-auto">
      <div class="top-pagination">
        <div class="">
          @if (itemsCount) {
            <dhs-pagination [itemsCount]="itemsCount" [limit]="limit"
              [startPage]="page" (pageChange)="onPageChanged($event)"
              (onLimitChanges)="onLimit($event)">
            </dhs-pagination>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="row filter-grid mt-3">
    @if (resouceDef.filter_form.default_open) {
      <div class="col-12 pl-4 pr-4">
        <div class="grid_filter">
          <!-- <span class="filter-arrow"><i class="fa fa-caret-up" aria-hidden="true"></i></span> -->
          <span class="close-filter-btn" (click)="displayFilter()">
            <i class="fa fa-times-circle" aria-hidden="true"></i></span>
            @if (resouceDef.filter_form.blocks) {
              <div class="filter-form">
                <kx-filter [config]="searchConfig" [fields]="resouceDef.filter_form"
                  (getFilter)="doSearch($event)" (resetFilter)="resetFormClick($event)">
                </kx-filter>
                <!-- <div class="col-md-3 col-lg-3 col-xl-3"></div> -->
              </div>
            }
          </div>
        </div>
      }
    </div>
    <div class="table-responsive mt-3">
      @if (keys.length>0) {
        <table class="base-table table-actions">
          <thead>
            <tr>
              @for (key of keys; track key) {
                @if (key.visible) {
                  <th class="text-capitalize w-25 text-center">
                    <span>{{key.display!=undefined?key.display:key}}</span>
                  </th>
                }
              }
              @if (resouceDef.capability!=undefined && resouceDef.capability.length>0) {
                <th scope="col">
                  <div class="table-row-actions">
                    <i class="fa fa-cog"></i>
                  </div>
                </th>
              }
            </tr>
          </thead>
          <tbody>
            @for (res of result; track res) {
              <tr>
                @for (key of keys; track key) {
                  @if (key.visible && key.default == undefined) {
                    <td class="text-center w-25">
                      @if (res[key['key']]!=undefined) {
                        <span class="dot {{res[key['key']]}}"></span>
                      }
                      @if (res[key['key']]==undefined) {
                        <span class="dot NA"></span>
                      }
                    </td>
                  }
                  @if (key.visible && key.default != undefined) {
                    <td class="text-center w-25">
                      @if (res[key['key']]!=undefined) {
                        <span>{{res[key['key']]}}</span>
                      }
                    </td>
                  }
                }
                @if (resouceDef.capability!=undefined && resouceDef.capability.length>0) {
                  <td>
                    <div class="table-row-actions">
                      <ng-template #popTemplate>
                        @for (action of resouceDef.capability; track action) {
                          <div>
                            <button class="p-dropdown-item" (click)="redirect(res,action)">
                              <span class="px-2">{{action.label}}</span>
                            </button>
                          </div>
                        }
                      </ng-template>
                      <i class="fa fa-ellipsis-v" area-hidden="true" [popover]="popTemplate"
                        placement="left top" container="body" containerClass="tabelcontextualmenu"
                      [outsideClick]="true"></i>
                    </div>
                  </td>
                }
              </tr>
            }
          </tbody>
        </table>
      }
    </div>
  </div>
  <!-- <div class="tracksampledotmob">
  <div class="_wf-db-seacrhmain">
    <div class="_wf-db-secricon" *ngIf="resouceDef.filter_form != undefined">
      <div class="_wf-db-fiterl-icon" (click)="displayFilter()">
        <i class="fa fa-filter" aria-hidden="true"></i>
      </div>
      <app-complex-search [config]="searchConfig" (onFilterChange)="filterClick($event);"></app-complex-search>
    </div>
  </div>
  <div class="text-capitalize _wf-sdts-allpointstop">
    <div class="_wf-sbts-trackfirstpoint">
      <div class="text-block-230"><i class="fa fa-circle" style="color:rgb(233, 230, 62);"></i></div>
      <div class="text-block-231">Pending</div>
    </div>
    <div class="_wf-sbts-trackfirstpoint">
      <div class="text-block-230"><i class="fa fa-circle" style="color: #44cdf7cb;"></i></div>
      <div class="text-block-231">Completed</div>
    </div>
    <div class="_wf-sbts-trackfirstpoint">
      <div class="text-block-230"><i class="fa fa-circle" style="color: rgb(224, 24, 24);"></i></div>
      <div class="text-block-231">Cancelled</div>
    </div>
    <div class="_wf-sbts-trackfirstpoint">
      <div class="text-block-230"><i class="fa fa-circle" style="color: rgb(0, 0, 0);"></i></div>
      <div class="text-block-231">NA</div>
    </div>
  </div>
  <div class="row filter-grid mt-3">
    <ng-container *ngIf="resouceDef.filter_form.default_open">
      <div class="col-12 pl-4 pr-4">
        <div class="grid_filter">
          <span class="filter-arrow"><i class="fa fa-caret-up" aria-hidden="true"></i></span>
          <span class="close-filter-btn" (click)="displayFilter()"><i class="fa fa-times-circle"
          aria-hidden="true"></i></span>
          <div class="filter-form" *ngIf="resouceDef.filter_form.blocks">
            <kx-filter [config]="searchConfig" [fields]="resouceDef.filter_form" (getFilter)="doSearch($event)" (resetFilter)="resetFormClick($event)">
            </kx-filter>
            <div class="col-md-3 col-lg-3 col-xl-3"></div>
          </div>
        </div>

      </div>
    </ng-container>
  </div>
  <div class="table-responsive mt-3">
    <table class="base-table table-actions" *ngIf="keys.length>0">
      <thead>
        <tr>
          <ng-container *ngFor="let key of keys">
            <th *ngIf="key.visible" class="text-capitalize w-25 text-center"><span>{{key.display!=undefined?key.display:key}}</span>
          </th>
        </ng-container>

        <th *ngIf="resouceDef.capability!=undefined && resouceDef.capability.length>0" scope="col">
          <div class="table-row-actions">
            <i class="fa fa-cog"></i>
          </div>
        </th>

      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let res of result">
        <ng-container *ngFor="let key of keys">
          <td class="text-center w-25" *ngIf="key.visible && key.default == undefined">
            <span *ngIf="res[key['key']]!=undefined" class="dot {{res[key['key']]}}"></span>
            <span *ngIf="res[key['key']]==undefined" class="dot NA"></span>
          </td>
          <td class="text-center w-25" *ngIf="key.visible && key.default != undefined">
            <span *ngIf="res[key['key']]!=undefined">{{res[key['key']]}}</span>
          </td>
        </ng-container>
        <td *ngIf="resouceDef.capability!=undefined && resouceDef.capability.length>0">
          <div class="table-row-actions">
            <ng-template #popTemplate>
              <div *ngFor="let action of resouceDef.capability">
                <button class="p-dropdown-item" (click)="redirect(res,action)">
                  <span class="px-2">{{action.label}}</span>
                </button>
              </div>
            </ng-template>
            <i class="fa fa-ellipsis-v" area-hidden="true" [popover]="popTemplate" placement="left top" container="body" containerClass="tabelcontextualmenu" [outsideClick]="true"></i>
          </div>
        </td>
      </tr>
    </tbody>

  </table>
</div>
<div class="ml-auto">
  <div class="top-pagination">
    <div class="">
      <dhs-pagination *ngIf="itemsCount" [itemsCount]="itemsCount" [limit]="limit" [startPage]="page" (pageChange)="onPageChanged($event)" (onLimitChanges)="onLimit($event)">
      </dhs-pagination>
    </div>
  </div>
</div>
</div> -->



@if (keys.length==0 || result.length==0) {
  <div class="text-center">No Data Found</div>
}
<!-- <div class="col-12" *ngIf="keys.length>0">
<div class="row">
  <div class="col-3">
    <ng-container>
      <div class="d-flex flex-row">
        <div class="p-2">Show</div>
        <div class="">
          <select class="form-control" (change)="onLimit($event);">
            <option class="ng-tns-c7-0">10</option>
            <option class="ng-tns-c7-0">20</option>
            <option class="ng-tns-c7-0">50</option>
          </select>
        </div>
        <div class="p-2">entries</div>
      </div>
    </ng-container>
  </div>
  <div class="col-9 kx-grid-pagination">
    <dhs-pagination *ngIf="itemsCount" [itemsCount]="itemsCount" [limit]="limit" [startPage]="page" (pageChange)="onPageChanged($event)">
    </dhs-pagination>
  </div>
</div>
</div> -->
</div>
</div>